export function customFormatDate(dateStr: string): string {
  const isoDate = dateStr.split('T')[0];
  const [year, monthIndex, dayOfMonth] = isoDate.split('-').map(Number);

  if (!year || !monthIndex || !dayOfMonth) {
    return dateStr;
  }

  const date = new Date(year, monthIndex - 1, dayOfMonth);

  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'short' });

  const getOrdinalSuffix = (day: number) => {
    if (day > 3 && day < 21) return 'th'; // Handle 11th, 12th, 13th
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };

  const ordinalSuffix = getOrdinalSuffix(day);

  return `${day}${ordinalSuffix} ${month}`;
}

// Example usage:
// const formattedDate = formatDate("2024-07-03");
// Output: "3rd July"
